module.exports = __webpack_public_path__ + "656c9899d22b166292448de76509d46c.svg";